import { render, staticRenderFns } from "./GiftCodeWidgetCard.vue?vue&type=template&id=2e068f69&"
import script from "./GiftCodeWidgetCard.vue?vue&type=script&lang=js&"
export * from "./GiftCodeWidgetCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftCodeWidgetCard.vue?vue&type=style&index=0&id=2e068f69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports